export default __webpack_public_path__ + "static/kampaus-work-2d73b82c1898c4fc3f3e81389f794e61.jpg";